export default __webpack_public_path__ + "static/media/add_directory.03b71a1b.svg";